import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../contexts/GlobalContext";
import { getDataCronDebug } from "../../../../hooks/api/apiDebug";
import DataCronDebug from "./DataCronDebug";
import './apiDebug.css';

export default function ViewCronDebug() {
  const globalContext = useContext(GlobalContext);
  const [inputCode, setInputCode] = useState("");
  const [datosApi, setDatosApi] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginaActual, setPaginaActual] = useState(1);
  const [totalPage, setTotalPage] = useState(null);

  const obtenerDatos = async (pagina = 1) => {
    setDatosApi([]);
    setLoading(true);

    const parametros = {
      page: paginaActual,
      limit: 10,
      // empresaId: globalContext.empresaActualId,
    };

    if (inputCode) parametros.sku = inputCode;

    try {
      const respuesta = await getDataCronDebug(inputCode, parametros);
      const nuevosDatos = respuesta.data?.data?.results || respuesta.data || [];
      const totalPage = respuesta.data?.data?.total / parametros.limit;
      setTotalPage(totalPage);
      setDatosApi(nuevosDatos);
      console.log(respuesta.data?.data?.total, respuesta.data?.data?.total)
    } catch (error) {
      console.error("Error en la API:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSiguiente = (param) => {
    let pagina = 1;
    if (param === "back") {
      pagina = paginaActual - 1;
    }else pagina = paginaActual + 1;

    setPaginaActual(pagina);
    obtenerDatos(pagina);
  };

  useEffect(() => {
    // obtenerDatos(paginaActual);
  }, [globalContext.empresaActualId]);

  return (
    <>
      <h1 className="text-center mt-5">Consultas para <strong>Debug Cron</strong></h1>
      <p className="text-center mt-2">Ingresa un CODE PROCESS para consultar</p>
      <div className="d-flex flex-column align-items-center justify-content-center">
        <div className="d-flex align-items-center justify-content-center mt-3">
          <div>
            <div className="container d-flex justify-content-center align-items-center mt-2">
              <h5 style={{ width: 130, textAlign: 'end', paddingRight: 20 }}>CODE</h5>
              <input
                style={{ width: 300, padding: '7px 0', textAlign: 'center' }}
                type="text"
                value={inputCode}
                onChange={(e) => setInputCode(e.target.value)}
              />
            </div>
          </div>
          <button
            onClick={() => {
              setPaginaActual(1);
              obtenerDatos(1);
            }}
            style={{
              padding: '0 27px',
              backgroundColor: '#014788',
              color: '#FFF',
              height: 40,
              borderRadius: '0 15px 0',
              marginLeft: 10
            }}
          >
            Buscar
          </button>
        </div>
        <div style={{maxWidth:500}}>
        {
          paginaActual > 1 &&
            <button
            onClick={()=> handleSiguiente("back")}
            style={{
              marginTop: 30,
              padding: '10px 25px',
              borderRadius: 10,
              backgroundColor: '#014788',
              color: 'white',
              border: 'none'
            }}
          >
            Anterior página
          </button>
        }
         {
          paginaActual < totalPage &&  
              <button
              onClick={handleSiguiente}
              style={{
                marginTop: 30,
                padding: '10px 25px',
                borderRadius: 10,
                backgroundColor: '#014788',
                color: 'white',
                border: 'none'
              }}
            >
              Siguiente página
            </button>
         }
        </div>
      </div>
      <div className="container d-flex flex-column justify-content-center align-items-center mt-5" style={{ gap: 60 }}>
        {
          datosApi && datosApi?.length > 0 ?
            (
              <>
                {datosApi.map((item, index) => (
                  <DataCronDebug key={index} data={item} />
                ))}
              </>
            ) :
            loading ? (
              <div className='col-12 d-flex justify-content-center align-items-center' style={{ height: 'calc(100vh - 400px)' }}>
                <div className="loader"></div>
              </div>
            ) : <></>
        }
      </div>
    </>
  );
}
